import { render, staticRenderFns } from "./Empresa-tab-endereco.vue?vue&type=template&id=1ed860ee&scoped=true&"
import script from "./Empresa-tab-endereco.vue?vue&type=script&lang=js&"
export * from "./Empresa-tab-endereco.vue?vue&type=script&lang=js&"
import style0 from "./Empresa-tab-endereco.vue?vue&type=style&index=0&id=1ed860ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed860ee",
  null
  
)

export default component.exports